import "./backdrop.scss";

const Backdrop = ({ onClick }) => {
  return <div onClick={onClick} className="backdrop-container"></div>;
};

export default Backdrop;
